import { Platform } from 'react-native'

import firebase, { getApp, initializeApp } from '@react-native-firebase/app'
import AsyncStorage from '@react-native-async-storage/async-storage'

firebase.setReactNativeAsyncStorage(AsyncStorage)

if (Platform.OS === 'web') {
  try {
    if (!window.setImmediate) {
      // @ts-expect-error firebase-web leverages setImmediate
      window.setImmediate = (cb: () => void) => {
        setTimeout(cb, 0)
      }
    }
    console.log('Initializing Firebase')
    initializeApp({
      apiKey: 'AIzaSyDuEU6qQp-R6lHNXa00qoaZkuFWk5YCIGI',
      authDomain: 'poker-powher.firebaseapp.com',
      databaseURL: 'https://poker-powher-default-rtdb.firebaseio.com',
      projectId: 'poker-powher',
      storageBucket: 'poker-powher.firebasestorage.app',
      messagingSenderId: '469309110195',
      appId: '1:469309110195:web:950bb015b0946fa3e07dc6',
      measurementId: 'G-CX8TLGZ6EH'
    })

    // module.setReactNativeAsyncStorage(AsyncStorage)
  } catch (e) {
    console.error('Error initializing Firebase', e)
  }
}

export const firebaseApp = () => getApp()
